import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  addChildNodeFailed,
  addChildNodeSuccess,
  addPropertySchemaFailed,
  addPropertySchemaSuccess,
  addRootNodeFailed,
  addRootNodeSuccess,
  deleteChildNodeFailed,
  deleteChildNodeSuccess,
  deleteRootNodeFailed,
  deleteRootNodeSuccess,
  editChildNodeFailed,
  editChildNodeSuccess,
  editPropertySchemaFailed,
  editPropertySchemaSuccess,
  editRootNodeFailed,
  editRootNodeSuccess,
  getChildNodesFailed,
  getChildNodesSuccess,
  getNodePropertiesFailed,
  getNodePropertiesSuccess,
  getRootNodesFailed,
  getRootNodesSuccess
} from '../actions/schema-explorer/Actions';
import {
  AddChildNode,
  AddPropertySchema,
  AddRootNode,
  DeleteChildNode,
  DeleteRootNode,
  EditChildNode,
  EditPropertySchema,
  EditRootNode,
  GetChildNodes,
  GetNodeProperties
} from '../actions/schema-explorer/ActionTypes';
import {
  addProperty,
  addResource,
  addRootNode,
  deleteResource,
  deleteRootNode,
  editProperty,
  editResource,
  editRootNode,
  getChildNodes,
  getResourceProperties,
  getRootNodes
} from '../api/SchemaExplorer';
import * as Constants from '../constants';

function* getRootNodesSaga() {
  try {
    const rootNodes = yield call(getRootNodes);
    yield put(getRootNodesSuccess(rootNodes));
  } catch (error) {
    yield put(getRootNodesFailed());
  }
}

function* watchForGetRootNodes() {
  yield takeLatest(Constants.GET_ROOT_NODES_SCHEMA, getRootNodesSaga);
}

function* getChildNodesSaga(action: GetChildNodes) {
  try {
    const parentVmid = action.payload.vmid;
    const childNodes = yield call(getChildNodes, parentVmid);
    yield put(getChildNodesSuccess(parentVmid, childNodes));
  } catch (error) {
    yield put(getChildNodesFailed());
  }
}

function* watchForGetChildNodes() {
  yield takeLatest(Constants.GET_CHILD_NODES_SCHEMA, getChildNodesSaga);
}

function* addRootNodeSaga(action: AddRootNode) {
  try {
    const addedNode = yield call(addRootNode, action.payload.rootNode);
    yield put(addRootNodeSuccess(addedNode));
  } catch (error) {
    yield put(addRootNodeFailed());
  }
}

function* watchForAddRootNode() {
  yield takeLatest(Constants.ADD_ROOT_NODE_SCHEMA, addRootNodeSaga);
}

function* editRootNodeSaga(action: EditRootNode) {
  try {
    const updatedNode = yield call(editRootNode, action.payload.rootNode);
    yield put(editRootNodeSuccess(updatedNode));
  } catch (error) {
    yield put(editRootNodeFailed());
  }
}

function* watchForEditRootNode() {
  yield takeLatest(Constants.EDIT_ROOT_NODE_SCHEMA, editRootNodeSaga);
}

function* deleteRootNodeSaga(action: DeleteRootNode) {
  try {
    yield call(deleteRootNode, action.payload.vmid);
    yield put(deleteRootNodeSuccess(action.payload.vmid));
  } catch (error) {
    yield put(deleteRootNodeFailed());
  }
}

function* watchForDeleteRootNode() {
  yield takeLatest(Constants.DELETE_ROOT_NODE_SCHEMA, deleteRootNodeSaga);
}

function* addChildNodeSaga(action: AddChildNode) {
  try {
    const addedNode = yield call(addResource, action.payload.childNode);
    yield put(addChildNodeSuccess(addedNode));
  } catch (error) {
    yield put(addChildNodeFailed());
  }
}

function* watchForAddChildNode() {
  yield takeLatest(Constants.ADD_CHILD_NODE_SCHEMA, addChildNodeSaga);
}

function* editChildNodeSaga(action: EditChildNode) {
  try {
    const updatedNode = yield call(editResource, action.payload.childNode);
    yield put(editChildNodeSuccess(updatedNode));
  } catch (error) {
    yield put(editChildNodeFailed());
  }
}

function* watchForEditChildNode() {
  yield takeLatest(Constants.EDIT_CHILD_NODE_SCHEMA, editChildNodeSaga);
}

function* deleteChildNodeSaga(action: DeleteChildNode) {
  try {
    yield call(deleteResource, action.payload.vmid);
    yield put(deleteChildNodeSuccess(action.payload.vmid));
  } catch (error) {
    yield put(deleteChildNodeFailed());
  }
}

function* watchForDeleteChildNode() {
  yield takeLatest(Constants.DELETE_CHILD_NODE_SCHEMA, deleteChildNodeSaga);
}

function* getNodePropertiesSaga(action: GetNodeProperties) {
  try {
    const properties = yield call(getResourceProperties, action.payload.vmid);
    yield put(getNodePropertiesSuccess(properties));
  } catch (error) {
    yield put(getNodePropertiesFailed());
  }
}

function* watchForGetNodeProperties() {
  yield takeLatest(Constants.GET_SCHEMA_NODE_PROPERTIES, getNodePropertiesSaga);
}

function* addPropertySaga(action: AddPropertySchema) {
  try {
    const addedProperty = yield call(addProperty, action.payload.property);
    yield put(addPropertySchemaSuccess(addedProperty));
  } catch (error) {
    yield put(addPropertySchemaFailed());
  }
}

function* watchForAddProperty() {
  yield takeLatest(Constants.ADD_PROPERTY_SCHEMA, addPropertySaga);
}

function* editPropertySaga(action: EditPropertySchema) {
  try {
    const updatedProperty = yield call(editProperty, action.payload.property);
    yield put(editPropertySchemaSuccess(updatedProperty));
  } catch (error) {
    yield put(editPropertySchemaFailed());
  }
}

function* watchForEditProperty() {
  yield takeLatest(Constants.EDIT_PROPERTY_SCHEMA, editPropertySaga);
}

export default function* schemaExplorerSaga() {
  yield all([
    watchForGetRootNodes(),
    watchForGetChildNodes(),
    watchForAddRootNode(),
    watchForEditRootNode(),
    watchForDeleteRootNode(),
    watchForAddChildNode(),
    watchForEditChildNode(),
    watchForDeleteChildNode(),
    watchForGetNodeProperties(),
    watchForAddProperty(),
    watchForEditProperty()
  ]);
}
